export const ASSETS_ROOT = 'https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master/';
